import React from 'react';

const Input = (props) => (
    <input 
        className="material-input" 
        {...props}
    />
)

export default Input;